// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";
import GradientHeader from "src/components/shared/displays/GradientHeader/GradientHeader";
import DeviceCare from "./DeviceCare/DeviceCare";
import SetUpWifi from "./SetUpWifi/SetUpWifi";

type VirtualRealityDeviceType = {
  title: string;
};

const VirtualRealityDevice = ({ title }: VirtualRealityDeviceType) => {
  const { t } = useTranslation("operating-manual");

  return (
    <OperatingManualContent title={title}>
      <Box
        id="set-up-wifi"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <GradientHeader header={`7.1 ${t("Instructions to Set Up Wi-Fi")}`} />
        <Box sx={{ mx: "20px" }}>
          <SetUpWifi />
        </Box>
      </Box>

      <Box
        id="vr-device-care"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <GradientHeader header={`7.2 ${t("VR Device Care")}`} />
        <Box sx={{ mx: "20px" }}>
          <DeviceCare />
        </Box>
      </Box>

      <Box
        id="device-lifetime-expectancy"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <GradientHeader header={`7.3 ${t("Device Lifetime Expectancy")}`} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mx: "20px",
          }}
        >
          <Typography>
            {t(
              "The estimated operational lifetime of this device is five (5) years under normal use conditions, as outlined in this manual."
            )}
          </Typography>
        </Box>
      </Box>
    </OperatingManualContent>
  );
};

export default VirtualRealityDevice;
